import React from 'react';

import Single from '../Single';

const RenderSingleWork = (props) => {
    const renderPosts = (posts, index) => {
        const post = posts[index];
        if (props.posts.fetched) {
            let hasFeaturedImage = null;
            if (post.better_featured_image) {
                hasFeaturedImage =
                    post.better_featured_image.media_details.sizes.large
                        .source_url;
            }
            return (
                <Single
                    key={post.id}
                    acf={post.acf || []}
                    type={post.type}
                    pId={post.id}
                    title={post.title.rendered}
                    content={post.content.rendered}
                    date={post.date}
                    formattedDate={post.formatted_date}
                    link={post.link}
                    featuredImage={hasFeaturedImage}
                    categories={post.categories}
                    tags={post.tags || []}
                />
            );
        }
    };

    return renderPosts(props.posts.posts, props.index);
};

export default RenderSingleWork;



// WEBPACK FOOTER //
// ./src/components/Pages/Work/RenderSingleWork.jsx